import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-37118066"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "no-user-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, " 登录 ")], -1));

const _hoisted_3 = {
  class: "login-content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "开启智慧教学之旅", -1));

const _hoisted_5 = {
  class: "avatar"
};
const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "账号登录", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  key: 1,
  style: {
    "position": "relative",
    "height": "100%"
  }
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "toggle-tip"
}, [/*#__PURE__*/_createTextVNode(" 切换 "), /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-qiehuan"
})], -1));

const _hoisted_12 = {
  class: "top-text"
};
const _hoisted_13 = {
  class: "user-name"
};
const _hoisted_14 = {
  class: "top-text"
};
const _hoisted_15 = {
  class: "user-name"
};
const _hoisted_16 = {
  class: "top-text"
};
const _hoisted_17 = {
  class: "user-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_RoleCard = _resolveComponent("RoleCard");

  return _openBlock(), _createElementBlock(_Fragment, null, [!$props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: require('@/assets/images/home/Booklist.png'),
    alt: ""
  }, null, 8, _hoisted_6)]), _createElementVNode("div", {
    class: "login-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.zhsLogin && $options.zhsLogin(...args))
  }, _hoisted_9)])])) : _createCommentVNode("", true), $props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_10, [$props.zhsRole == 1 || $props.zhsRole == 2 ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 0,
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      class: "role-dropdown"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roleList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.name,
          onClick: $event => $options.toggleZhsRole(item, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  })) : _createCommentVNode("", true), $data.currentRole == 3 || $data.currentRole == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['user-content', [1361, 203].includes($data.school_id) ? 'act203' : ''])
  }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString($props.userInfo.realname) + "，您好！", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.student
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])], 2)) : _createCommentVNode("", true), $data.currentRole == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(['user-content', [1361, 203].includes($data.school_id) ? 'act203' : ''])
  }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString($props.userInfo.realname) + "老师，您好！", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.teacher
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])], 2)) : _createCommentVNode("", true), $data.currentRole == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: _normalizeClass(['user-content', [1361, 203].includes($data.school_id) ? 'act203' : ''])
  }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString($props.userInfo.realname) + "管理员，您好！", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.manage
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
}